import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const fetchAnestesikoder = async ({ query }: { query?: string } = {}) => {
    const store = useStore();

    try {
        const params: { q?: string } = {};

        if (query) {
            params.q = query;
        }

        const { subsetName } = await store.dispatch("operation/anestesikod/fetchAnestesikoder", {
            filterParams: params,
            displayMode: true,
        });

        return store.getters["operation/anestesikod/anestesikodSubset"]({ subsetName, displayMode: true });
    } catch (error) {
        flashWarning("Kunde inte hämta anestesikoder");
    }
};
